import React, { Component } from 'react';
import PropTypes from "prop-types";
import Modal from 'react-modal';
import moment from 'moment';
import Datetime from 'react-datetime';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { get, postWithHeaders, patch, _delete } from "../../../server/actions";
import { date_format } from '../../../server/constants';
import { getManageSchoolSettingList, setSchoolYearSettingsToSession } from './manageSchoolSettings'
let schoolId = 0;
let loggedUser = '';
let userName = "";
const customManageUsersStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
const formGroupMargin = {
    marginBottom: '5px'
}
const formGroupPadding = {
    padding: '5px'
}
class ManageSchools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schoolList: [],
            headindText: "Add",
            startDate: new Date(),
            endDate: new Date(),
            schoolYear: "",
            schoolYears: "",
            modalIsOpen: false,
            attendanceFactor: 0.00,
            regRedFedReimbRate: 0.0000,
            regFreFedReimbRate: 0.0000,
            regTotFedReimbRate: 0.0000,
            regRedStateReimbRate: 0.0000,
            regFreStateReimbRate: 0.0000,
            regTotStateReimbRate: 0.0000,
            needyRedFedReimbRate: 0.0000,
            needyFreFedReimbRate: 0.0000,
            needyTotFedReimbRate: 0.0000,
            needyRedStateReimbRate: 0.0000,
            needyFreStateReimbRate: 0.0000,
            needyTotStateReimbRate: 0.0000
        }
        this.getManageSchools = this.getManageSchools.bind(this);
        this.saveSchoolYear = this.saveSchoolYear.bind(this);
        this.loadSchoolYearRec = this.loadSchoolYearRec.bind(this);
    }
    componentDidMount() {

        if (sessionStorage.getItem('ROLE') === 'ROLE_SUPERADMIN') {
            schoolId = this.props.school._links.self.href.split('/').pop();
        }
        else {
            schoolId = sessionStorage.getItem('SchoolId');
        }
        this.getManageSchools();
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillMount() {
        loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
    }
    getManageSchools = () => {
        getManageSchoolSettingList(sessionStorage.getItem('SchoolId')).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let schoolListData = [];
            console.log('data', data);
            data._embedded.schoolYears.map(col => {
                let status = false;
                let d = new Date();
                let cd = moment.utc(d).local()
                let sd = moment.utc(col.sessionStartDateTime).local();
                let ed = moment.utc(col.sessionEndDateTime).local();
                if ((sd._d <= cd._d) && (cd._d <= ed._d)) {
                    status = true;
                } else if (ed._d <= cd._d) {
                    status = false;
                } else if (sd._d >= cd._d) {
                    status = true;
                }
                schoolListData.push({
                    name: col.name,
                    sessionStartDateTime: col.sessionStartDateTime,
                    sessionEndDateTime: col.sessionEndDateTime,
                    schoolYear: col.schoolYear,
                    attendanceFactor: col.attendanceFactor,
                    regRedFedReimbRate: col.regRedFedReimbRate,
                    regFreFedReimbRate: col.regFreFedReimbRate,
                    regTotFedReimbRate: col.regTotFedReimbRate,
                    regRedStateReimbRate: col.regRedStateReimbRate,
                    regFreStateReimbRate: col.regFreStateReimbRate,
                    regTotStateReimbRate: col.regTotStateReimbRate,
                    needyRedFedReimbRate: col.needyRedFedReimbRate,
                    needyFreFedReimbRate: col.needyFreFedReimbRate,
                    needyTotFedReimbRate: col.needyTotFedReimbRate,
                    needyRedStateReimbRate: col.needyRedStateReimbRate,
                    needyFreStateReimbRate: col.needyFreStateReimbRate,
                    needyTotStateReimbRate: col.needyTotStateReimbRate,
                    schoolPdfUrl: col.schoolPdfUrl,
                    schoolYears: col._links.self.href.split("/").pop(),
                    editStatus: status
                })
            });

            this.setState({
                schoolList: schoolListData,
            }, () => {
                setSchoolYearSettingsToSession(sessionStorage.getItem('SchoolId'), data._embedded.schoolYears);
            })
        }).catch(
            (error) => {
                console.log('Get manage school response', error)
            }
        );
    }

    saveSchoolYear = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        let headers = {
            'Content-Type': 'application/json'
        };
        let sd = this.state.startDate
        sd.setHours(0)
        sd.setMinutes(0)
        sd.setSeconds(0)
        let ed = this.state.endDate
        ed.setHours(23)
        ed.setMinutes(59)
        ed.setSeconds(59)

        let data = JSON.stringify({
            loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserInfo')).username,
            mealSchool: "/mealManage/mealSchools/" + sessionStorage.getItem('SchoolId'),
            schoolYear: new Date(this.state.startDate).getFullYear(),
            name: new Date(this.state.startDate).getFullYear() + '-' + new Date(this.state.endDate).getFullYear(),
            sessionStartDateTime: moment(sd).utc().format("YYYY-MM-DDTHH:mm:ss"),
            sessionEndDateTime: moment(ed).utc().format("YYYY-MM-DDTHH:mm:ss"),
            attendanceFactor: this.state.attendanceFactor,
            regRedFedReimbRate: this.state.regRedFedReimbRate,
            regFreFedReimbRate: this.state.regFreFedReimbRate,
            regTotFedReimbRate: this.state.regTotFedReimbRate,
            regRedStateReimbRate: this.state.regRedStateReimbRate,
            regFreStateReimbRate: this.state.regFreStateReimbRate,
            regTotStateReimbRate: this.state.regTotStateReimbRate,
            needyRedFedReimbRate: this.state.needyRedFedReimbRate,
            needyFreFedReimbRate: this.state.needyFreFedReimbRate,
            needyTotFedReimbRate: this.state.needyTotFedReimbRate,
            needyRedStateReimbRate: this.state.needyRedStateReimbRate,
            needyFreStateReimbRate: this.state.needyFreStateReimbRate,
            needyTotStateReimbRate: this.state.needyTotStateReimbRate
        });
        if (this.state.headindText === "Edit") {
            patch('/schoolYears/' + this.state.schoolYears + '?access_token=', data).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                _addNotification("School Years Updated Successfully.", this);
                this.setState({ loading: false, modalIsOpen: false });
                this.getManageSchools();
            })
                .catch(
                    (error) => {
                        _addNotification("School Years Not Updated. Please try again later.", this)
                        this.setState({ loading: false });
                        console.log('School Years response', error)
                    }
                )
        } else {
            postWithHeaders('/schoolYears?access_token=', data, headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.text();
            }).then(data => {
                _addNotification("School Year data saved.", this);
                this.setState({ loading: false, modalIsOpen: false });
                this.getManageSchools();
            }).catch(
                (error) => {
                    console.log('School Year data not saved', error);
                    this.setState({ loading: false });
                }
            );
        }
    }
    openModal(e, userType, actionType) {
        e.preventDefault();
        if (actionType === 'EDIT') {
            this.setState({ headindText: "Edit" });
        } else {
            this.setState({ headindText: "Add" });
        }
        if (userType !== '') {
            this.setState({
                startDate: moment.utc(userType.sessionStartDateTime).local()._d,
                endDate: moment.utc(userType.sessionEndDateTime).local()._d,
                schoolYear: userType.schoolYear,
                schoolYears: userType.schoolYears,
                attendanceFactor: userType.attendanceFactor,
                regRedFedReimbRate: userType.regRedFedReimbRate,
                regFreFedReimbRate: userType.regFreFedReimbRate,
                regTotFedReimbRate: userType.regTotFedReimbRate,
                regRedStateReimbRate: userType.regRedStateReimbRate,
                regFreStateReimbRate: userType.regFreStateReimbRate,
                regTotStateReimbRate: userType.regTotStateReimbRate,
                needyRedFedReimbRate: userType.needyRedFedReimbRate,
                needyFreFedReimbRate: userType.needyFreFedReimbRate,
                needyTotFedReimbRate: userType.needyTotFedReimbRate,
                needyRedStateReimbRate: userType.needyRedStateReimbRate,
                needyFreStateReimbRate: userType.needyFreStateReimbRate,
                needyTotStateReimbRate: userType.needyTotStateReimbRate
            })
        } else {
            this.setState({
                startDate: new Date(),
                endDate: new Date(),
                attendanceFactor: 0.00,
                regRedFedReimbRate: 0.0000,
                regFreFedReimbRate: 0.0000,
                regTotFedReimbRate: 0.0000,
                regRedStateReimbRate: 0.0000,
                regFreStateReimbRate: 0.0000,
                regTotStateReimbRate: 0.0000,
                needyRedFedReimbRate: 0.0000,
                needyFreFedReimbRate: 0.0000,
                needyTotFedReimbRate: 0.0000,
                needyRedStateReimbRate: 0.0000,
                needyFreStateReimbRate: 0.0000,
                needyTotStateReimbRate: 0.0000
            })
        }
        this.setState({ modalIsOpen: true });
    }
    loadSchoolYearRec = (id) => {
        this.context.router.history.push({
            pathname: '/schoolAdmin/manageSchoolRec',
            state: {
                yid: id,
                data: this.state.schoolList
            }
        });
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    selectStartDate = (e) => {
        let sd = new Date(e);
        sd.setHours(0)
        sd.setMinutes(0)
        sd.setSeconds(0)
        //let stDtFullYear = new Date(e).getFullYear();
        this.setState({ startDate: sd })
    }
    selectEndDate = (e) => {
        let ed = new Date(e);
        ed.setHours(0)
        ed.setMinutes(0)
        ed.setSeconds(0)
        //let fullYear = new Date(e).getFullYear();
        this.setState({ endDate: ed })
    }
    deleteSchoolYear = ({ mealSchoolId, deleteRec }) => {
        const { schoolYear } = deleteRec;
        this.setState({ loading: true });
        _delete(`/${mealSchoolId}/schoolYear/${schoolYear}?access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                _addNotification('Successfully deleted school year data.', this);
                this.setState({ loading: false, showDeleteModal: false, deleteRecId: 0 });
                this.getManageSchools();
            }).catch(error => {
                this.setState({ loading: false, showDeleteModal: false, deleteRecId: 0 });
                _addNotificationError('Could not delete school year data.', this);
            });
    }
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>Manage School</span>
                            </h2>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section text-right" style={{ marginTop: '15px' }}>
                            {/*  <button className='btn btn-success button-sm' onClick={() => {
                                this.context.router.history.push({
                                    pathname: '/schoolAdmin/automateSchoolYear',
                                    state: {
                                        data: this.state.schoolList
                                    }
                                });
                            }}><i className="fa fa-cog" />  Migrate to New School Year
                            </button> */}
                            {/* <button className="btn btn-success button-sm add-btn-sm"
                                onClick={(e) => this.loadSchoolYearRec('0')}><i className="fa fa-plus" /> Add New</button> */}
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="table-responsive ">
                                <table className="table table-hover">
                                    <thead>
                                        <tr className="bg-success base-reverse">
                                            <th>Session name</th>
                                            <th>Start date</th>
                                            <th>End date</th>
                                            <th width="40%">Instructions for lunch program</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <div id="noSchool" style={{ display: 'none' }} className="noSchool">
                                            <span>Oops, We found nothing. Try Adding new users.</span>
                                        </div>

                                        {
                                            this.state.schoolList.map(col => {
                                                return (<tr>
                                                    <td>{col.name}</td>
                                                    <td>{moment.utc(col.sessionStartDateTime).local().format(date_format())}</td>
                                                    <td>{moment.utc(col.sessionEndDateTime).local().format(date_format())}</td>
                                                    <td>{col.schoolPdfUrl}</td>
                                                    <td className="actions text-center" style={{ whiteSpace: 'nowrap' }}>
                                                        {col.editStatus === true ?
                                                            <div> {/* onClick={(e) => this.openModal(e,col,"EDIT")}><i */}
                                                                <a className="edit-btn" data-id={col.schoolYears} title="Edit"
                                                                    onClick={(e) => {
                                                                        let id = e.target.parentElement.getAttribute('data-id')
                                                                        this.loadSchoolYearRec(id)
                                                                    }}><i
                                                                        className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon" /></a>
                                                                <a className="edit-btn" data-id={col.schoolYears} title="Delete"
                                                                    onClick={(e) => {
                                                                        this.setState({ showDeleteModal: true, deleteRec: col });
                                                                    }}><i
                                                                        className="fa fa-trash tbl-rounded-icon bg-color-1 fa-icon" /></a>
                                                            </div> : <div>
                                                                <span title="Disabled" className="edit-btn"><i style={{ cursor: 'not-allowed' }}
                                                                    className="fa fa-pencil tbl-rounded-icon bg-color-light-grey fa-icon" /></span>
                                                            </div>}

                                                    </td>
                                                </tr>)
                                            })
                                        }
                                    </tbody>
                                </table>

                            </div>

                        </div>


                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customManageUsersStyles}
                            contentLabel="Activation"
                        >
                            <div className="modal-header" style={formGroupPadding}>
                                <h4 className="modal-title modal-title-color" id="deleteLabel">{this.state.headindText === "Add" ? "Add School Year" : "Edit School Year"}</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" style={formGroupMargin}>
                                            <label className="custom-label col-md-6 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                            <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                <Datetime ref='calendar' dateFormat="MM/DD/YYYY" timeFormat={false}
                                                    closeOnSelect={true} value={this.state.startDate}
                                                    onChange={this.selectStartDate.bind(this)} renderInput={this.renderInput} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" style={formGroupMargin}>                                            <div className="form-group">
                                            <label className="custom-label col-md-6 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                            <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                <Datetime ref='calendar' dateFormat="MM/DD/YYYY" timeFormat={false}
                                                    closeOnSelect={true} value={this.state.endDate}
                                                    onChange={this.selectEndDate.bind(this)} renderInput={this.renderInput} />
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="attendanceFactor">Attendance Factor:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="attendanceFactor" value={this.state.attendanceFactor}
                                                        placeholder="0.00" name="attendanceFactor" onChange={(e) => {
                                                            this.setState({ 'attendanceFactor': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 text-center">
                                            <h5>Federal Reimbursement</h5>
                                        </div>
                                        <div className="col-md-6  text-center">
                                            <h5>State Reimbursement</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="control-label col-sm-12"><strong>Regular</strong></label>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regRedFedReimbRate">Reduced Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regRedFedReimbRate"
                                                        placeholder="0.0000" name="regRedFedReimbRate" value={this.state.regRedFedReimbRate} onChange={(e) => {
                                                            this.setState({ 'regRedFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regFreFedReimbRate">Free Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regFreFedReimbRate"
                                                        placeholder="0.0000" name="regFreFedReimbRate" value={this.state.regFreFedReimbRate} onChange={(e) => {
                                                            this.setState({ 'regFreFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regTotFedReimbRate">Total Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regTotFedReimbRate"
                                                        placeholder="0.0000" name="regTotFedReimbRate" value={this.state.regTotFedReimbRate} onChange={(e) => {
                                                            this.setState({ 'regTotFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-sm-12"><strong>Needy (marked with * above)</strong></label>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyRedFedReimbRate">Reduced Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" value={this.state.needyRedFedReimbRate} id="needyRedFedReimbRate"
                                                        placeholder="0.0000" name="needyRedFedReimbRate" onChange={(e) => {
                                                            this.setState({ 'needyRedFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyFreFedReimbRate">Free Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="needyFreFedReimbRate"
                                                        placeholder="0.0000" name="needyFreFedReimbRate" value={this.state.needyFreFedReimbRate} onChange={(e) => {
                                                            this.setState({ 'needyFreFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyTotFedReimbRate">TotalServings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="needyTotFedReimbRate"
                                                        placeholder="0.0000" name="needyTotFedReimbRate" value={this.state.needyTotFedReimbRate} onChange={(e) => {
                                                            this.setState({ 'needyTotFedReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="control-label col-sm-12"><strong>Regular</strong></label>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regRedStateReimbRate">Reduced Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regRedStateReimbRate"
                                                        placeholder="0.0000" name="regRedStateReimbRate" value={this.state.regRedStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'regRedStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regFreStateReimbRate">Free Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regFreStateReimbRate"
                                                        placeholder="0.0000" name="regFreStateReimbRate" value={this.state.regFreStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'regFreStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="regTotStateReimbRate">Total Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="regTotStateReimbRate"
                                                        placeholder="0.0000" name="regTotStateReimbRate" value={this.state.regTotStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'regTotStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-sm-12"><strong>Needy (marked with * above)</strong></label>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyRedStateReimbRate">Reduced Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="needyRedStateReimbRate"
                                                        placeholder="0.0000" name="needyRedStateReimbRate" value={this.state.needyRedStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'needyRedStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyFreStateReimbRate">Free Servings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="needyFreStateReimbRate"
                                                        placeholder="0.0000" name="needyFreStateReimbRate" value={this.state.needyFreStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'needyFreStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="form-group row" style={formGroupMargin}>
                                                <label className="control-label col-sm-6" htmlFor="needyTotStateReimbRate">TotalServings:</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" id="needyTotStateReimbRate"
                                                        placeholder="0.0000" name="needyTotStateReimbRate" value={this.state.needyTotStateReimbRate} onChange={(e) => {
                                                            this.setState({ 'needyTotStateReimbRate': e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer" style={formGroupPadding}>
                                    <form>
                                        <button type="button" className="btn btn-sm btn-danger"
                                            onClick={() => this.setState({ modalIsOpen: false })}
                                            style={{ margin: 0, fontSize: 14 }}><i
                                                className="glyphicon glyphicon-remove" /> Cancel
                                        </button>
                                        <button type="button" className="btn btn-sm btn-success"
                                            onClick={this.saveSchoolYear}
                                            style={{ margin: 0, marginLeft: 5, fontSize: 14 }}><i
                                                className="glyphicon glyphicon-ok" /> Save
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </Modal>

                        <Modal isOpen={this.state.showDeleteModal}
                            onRequestClose={() => { this.setState({ showDeleteModal: false, deleteRec: {} }) }} style={customManageUsersStyles}
                            contentLabel="Example Modal">
                            <div className="modal-header">
                                <h4 className="modal-title modal-title-color" id="deleteLabel">Delete school year</h4>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete school year?</p>
                            </div>
                            <div className="text-right">
                                <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                    onClick={() => this.setState({ showDeleteModal: false, deleteRec: {} })}><i
                                        className="glyphicon glyphicon-remove"
                                        style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                </button>
                                <button type="button" className="btn btn-success btn-xs"
                                    style={{ margin: '0 0 0 5px' }} onClick={() => {
                                        const mealSchoolId = sessionStorage.getItem('SchoolId');
                                        this.deleteSchoolYear({ mealSchoolId, deleteRec: this.state.deleteRec });
                                    }}
                                    id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                                </button>
                            </div>
                        </Modal>

                    </div>
                </div>
            </div>
        );
    }
}
ManageSchools.contextTypes = {
    router: PropTypes.object.isRequired
};
export default ManageSchools;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageSchools/manageSchools.jsx